import dayjs from 'dayjs';
import fnMedian from 'frontend-utils/utils/numeric/find-median';

// Helper function that expects an array of unix extract_datetimes per period and returns the maximum of the median per day/period
// [ [ unix extract_datetime_1, unix extract_datetime_2, ...], [ unix extract_datetime_1, unix extract_datetime_2, ...], ... ] -> unix timestamp
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getUpdateTimestampFromExtractDatetimes(
  extractDatetimesUnix: number[][],
) {
  const medianPerPeriod: number[] = [];
  let updateTimestamp = null;

  // Calculate the median per period
  extractDatetimesUnix?.forEach((extractDateTimesUnixPerPeriod) => {
    // Only take median of extract_datetimes per period if there is at least one extract_datetime
    if (extractDateTimesUnixPerPeriod.length) {
      const medianExtractDateTimeForPeriod = fnMedian(
        extractDateTimesUnixPerPeriod,
      );

      if (medianExtractDateTimeForPeriod) {
        medianPerPeriod.push(medianExtractDateTimeForPeriod);
      }
    }
  });

  if (medianPerPeriod.length) {
    const max = Math.max.apply(null, medianPerPeriod);
    updateTimestamp = dayjs.unix(max);
  }

  return updateTimestamp;
}
